<template>
  <div>
    <div v-observe-visibility="{
         callback: visibilityChanged,
         throttle: 300,
         intersection: {
            threshold: 0.3,
          },
         }"
         class="h-screen w-full relative overflow-x-hidden"
         style="scroll-snap-align: start"
    >
<!--        <img class="image-hero" :class="{'appear':isVisible, 'object-contain': project, 'object-cover':!project}" :src="picture.path" :alt="picture.title[locale()]">-->
        <img class="image-hero" :class="{'appear':isVisible}" :src="picture.path" :alt="picture.title[locale()]">

        <div class="absolute bottom-0 w-full text-center opacity-0" :class="{'appear':isVisible}">
            <mouse-scroll class="inline-block"></mouse-scroll>
        </div>
        <div :class="project ? 'justify-center': 'max-w-2xl'" class="h-screen w-screen top-0 absolute flex items-center z-10">
            <div class="text-primary unselectable text-left px-4 md:p-6">
              <h2 class="text-4xl md:text-6xl tracking-tight leading-none">{{picture.title[locale()]}}</h2>
              <p class="tex-xs mt-4" v-if="!project"><span class="slogan-description">{{picture.excerpt[locale()]}}</span></p>
            </div>
        </div>
    </div>
  <div class="project-description" v-if="project" style="scroll-snap-align: start">
    <div class="text-primary text-2xl ">{{T('project')}}: {{picture.title[locale()]}}</div>
    <div class="text-gray-400 text" v-html="project.description[locale()]"></div>
  </div>
  </div>
</template>
<script>
    import MouseScroll from "../components/MouseScroll";
    export default {
        components:{MouseScroll},
        name: 'cover-hero',
        props: {
            picture: {
                type:Object,
                required:true
            },
            project: {
                type:Object,
                default:null
            },

        },
        data(){
          return{
              isVisible: false
          }
        },
        methods:{
            visibilityChanged (isVisible, entry) {
                this.isVisible = isVisible
                if(isVisible){
                    this.$store.commit('setActiveProjectPath', this.picture.path);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

    .image-hero{
        @apply w-full h-full object-cover;
        opacity: 0;
        transition: all 0.5s ease;

    }
    .appear{
        opacity: 1;
    }

    .project-description{
      @apply pt-32 px-4;
      max-width: 1170px;
      margin: auto;
    }

    .slogan-description{
      @apply items-center inline-flex;
      &:before{
        content: '';
        @apply border border-gray-600;
        width:30px;
        margin-right: 10px;
      }
    }

</style>
